var YoutubeAPI_ready = false;

function onYouTubeIframeAPIReady(){
	YoutubeAPI_ready = true;
	VideoPlayer.load_videos();
}


var VideoPlayer = {

	/******
	*      CLASS DISPONIBLES POUR LE VIDEO CONTAINER 
	*	
	*				autoplay
	*				controls
	*				fullscreen
	*				rel
	*				showinfo
	*       loop
	*
	*******/

	players_list:[],


	init:function(){
		/*  ADD ALL PLAYER THAT ARE NOT YOUTUBE  */
		$(".video-player").each(function(){
			if(!$(this).hasClass("youtube-player-container")){

				if($(this).hasClass("controls")){
					var _passive = false;
				}else{
					var _passive = true;
				}
				
				if($(this).hasClass("autoplay")){
					$(this).addClass("playing")
				}

				var _player = $(this).find("video");
				
				_player.on("play", function(){
					VideoPlayer.playLocalVideo();
				});
				_player.on("pause", function(){
					VideoPlayer.pauseLocalVideo();
				});
				VideoPlayer.players_list.push[{player:_player, type:"video", passive:_passive}]
			}
		});
	},
	playLocalVideo:function(){
		Debug.log("PLAY LOCAL VIDEO");
	},
	pauseLocalVideo:function(){
		Debug.log("PAUSE LOCAL VIDEO");
	},
	load_videos:function(){
		$(".youtube-player-container").each(function(){
			VideoPlayer.load_video($(this));
		});
	},
	load_video:function(pTarget){

	/*	Debug.log("LOAD YOUTUBE VIDEO : " + pTarget.find(".youtube-player").attr("id"));*/

		if(pTarget.find(".youtube-player").attr("data-video") == undefined){

			setTimeout(function(){
				/*Debug.log("PAS DE SRC, ON RETENTE");*/
				VideoPlayer.load_video(pTarget);
			}, 400);

		}else{

			var _video_id = pTarget.find(".youtube-player").attr("id");

			pTarget.find(".shadow").on("click touchend", function(e){
				if(e.type == 'touchend'){
					$(this).off("click"); 
				}

				VideoPlayer.stop_video();
			});


			var _autoplay = pTarget.hasClass("autoplay") ? 1 : 0;		
			var _rel = pTarget.hasClass("rel") ? 1 : 0;			
			var _controls = pTarget.hasClass("controls") ? 1 : 0;
			var _fullscreen = pTarget.hasClass("no-fullscreen") ? 0 : 1;			
			var _showinfo = pTarget.hasClass("showinfo") ? 1 : 0;


			if(pTarget.hasClass("loop")){
				var _playlist = $("#" + _video_id).attr("data-video");
				var _loop = 1;
			}else{
				var _playlist = "";
				var _loop = 0;
			}
			/*
			Debug.log("_____ CREATIN PLAYER YOUTUBE : " + _video_id + " ________");
			Debug.log("     _autoplay => " + _autoplay);
			Debug.log("     _rel => " + _rel);
			Debug.log("     _controls => " + _controls);
			Debug.log("     _fullscreen => " + _fullscreen);
			Debug.log("     _showinfo => " + _showinfo);
			Debug.log("     _loop => " + _loop);
			Debug.log("_____________________________________");
*/

			var player = new YT.Player(_video_id , {
				height: '100%',
				width: '100%',
				videoId: $("#" + _video_id).attr("data-video"),
				playerVars: {
					/*
					autoplay:_autoplay,
					rel:_rel,
					controls:_controls,
					fs:_fullscreen,
					showinfo:_showinfo,
					loop:_loop,
					playlist:_playlist
					*/
				},
				events: {
					'onReady': VideoPlayer.onPlayerReady,
					'onStateChange': VideoPlayer.onPlayerStateChange
				}
			});

			var _passive = pTarget.hasClass("passive") ? 1 : 0;

			VideoPlayer.players_list.push({player:player, type:"youtube", passive:_passive});
		}

	}, 
	onPlayerReady:function(e){
		if($("#" + e.target.getIframe().id).parent().hasClass("muted")){
			e.target.mute();
		}
	},
	onPlayerStateChange:function(e){
		//Debug.log("PLAYER STATE CHANGE : " + e.data + " == " + YT.PlayerState.PLAYING + "   // from : " + e.target.getIframe().id);

		/*Debug.log("WHO IS : "  + e.target.getIframe().id);*/

		if(e.data == YT.PlayerState.PLAYING){
			VideoPlayer.video_isPlaying(e.target.getIframe().id);
		}else{
			VideoPlayer.video_isStoping(e.target.getIframe().id);
		}
	},
	video_isPlaying:function(pID){

		/* STOP ALL VIDEOS */
		for(var i = 0; i < VideoPlayer.players_list.length; i++){

			if(VideoPlayer.players_list[i].type =="youtube"){

				if(VideoPlayer.players_list[i].player.getIframe().id != pID)	{
					
					if(VideoPlayer.players_list[i].passive != 1){
						VideoPlayer.players_list[i].player.stopVideo();
					}
					
				}else{
					//Debug.log(" PLAYER VIDEO EN COURS")
				}

			}
		}


		$("#" + pID).parent().addClass("playing");

		if($("#" + pID).parent().hasClass("cinema-mode")){

			$("body").addClass("no-scroll");
			$(".header").addClass("hidden");

			var _esp_dispo = ($(window).innerHeight() - $("#" + pID).parent().innerHeight())/2;

			var _scrollDest = $("#" + pID).parent().offset().top - _esp_dispo;

			$("html, body").animate({scrollTop:_scrollDest}, 500);	
		}
	},
	video_isStoping:function(pID){
		$("#" + pID).parent().removeClass("playing");
		$("body").removeClass("no-scroll");
		$(".header").removeClass("hidden");
	},
	stop_video:function() {
		Debug.log("STOP VIDE0 : " + VideoPlayer.players_list.length);
		for(var i = 0; i < VideoPlayer.players_list.length; i++){
			if(VideoPlayer.players_list[i].type =="youtube"){
				VideoPlayer.players_list[i].player.pauseVideo();
			}
		}			
	}
}

$(window).load(function(){
	if($(".video-player").length){
		VideoPlayer.init();
	}
})